import type { FunctionComponent } from 'react';

import { CardGeneratingIndicator, CardTitle } from '~/ui/core/card/CardHeader';

type JobArchitectureCardTitleProps = {
    readonly isGenerating: boolean;
    readonly title: string;
};

export const JobArchitectureCardTitle: FunctionComponent<JobArchitectureCardTitleProps> = ({ isGenerating, title }) => (
    <CardTitle title={title}>
        <span className="min-w-0 line-clamp-2">
            {title}
            {isGenerating && <CardGeneratingIndicator />}
        </span>
    </CardTitle>
);
